export default "__VITE_PUBLIC_ASSET__1730c051__"